import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getFromStorage } from "../components/utility/Storage";

export default function ProtectedRoute() {
    const user = getFromStorage("dnr_a")
    const errors = ["", undefined, null];

    if (!errors.includes(user) && !errors.includes(user?.auth)) {
        return <Outlet />;
    } else {
        return <Navigate to="/admin" />;
    }
}
